import { TransferApi } from 'api/endpoints/Transfer';
import { procurementApi } from 'api/endpoints/Procurement';
import { getTenantFromToken } from 'utils/routeUtils';
import { receptionApi } from 'api/endpoints/Reception';
import { processApi } from 'api/endpoints/Process';

const formProps = type => {
  const config = {
    transfer: {
      title: 'Transfer Items',
      fetchFormApi: TransferApi.transferForm,
      fetchEditFormApi: TransferApi.transferEditForm,
      createApi: TransferApi.createTransfer,
      updateApi: TransferApi.updateTransfer,
      reportPath: `/transferReport`
    },
    procurement: {
      title: 'Procurement',
      fetchFormApi: procurementApi.procurementForm,
      fetchEditFormApi: procurementApi.editProcurementForm,
      createApi: procurementApi.createProcurement,
      updateApi: procurementApi.updateProcurement,
      reportPath: `/procurementReport`
    },
    reception: {
      title: 'Reception',
      fetchFormApi: receptionApi.receptionForm,
      fetchEditFormApi: receptionApi.editReceptionForm,
      createApi: receptionApi.createReception,
      updateApi: receptionApi.updateReception,
      reportPath: `/receptionReport`
    },
    process: {
      title: 'Process',
      fetchFormApi: processApi.processForm,
      fetchEditFormApi: processApi.editProcessForm,
      createApi: processApi.createProcess,
      updateApi: processApi.updateProcess,
      reportPath: `/processReport`
    }
  };
  return config[type] || {};
};

export default formProps;
